import apiConfig from "../config";
import DataHeaderType from "../../Types/DataHeaderType";

type Response = {
	data: DataHeaderType[]
};

const programsMenuApi = (): Promise<DataHeaderType[]> => {
	return apiConfig()
		.get<Response>(`/v2/content/header/programs`)
		.then(({ data }) => {
			return data;
		})
		.catch(({ data }) => {
			return data;
		});
};

export default programsMenuApi;
